<script>
import topMenu from "@/views/marketing/topMenu.vue";
export default {
  name: "partnerCombo",
  components: {
    topMenu
  }
};
</script>

<template>
  <topMenu :defaultTopSelectActive="3" :defaultTopSelect="[3]"></topMenu>
</template>

<style scoped lang="scss"></style>
